export type Lang = "pt" | "en";

export type Strings = {
  footerVisit: string;
  verifyTitle: string;
  verifyInstruction: string;
  verifyButton: string;
  toastDoneTitle: string;
  toastVerifiedDesc: string;
  toastErrorTitle: string;
  genericError: string;
  successTitle: string;
  successDesc: string;
  errorTitle: string;
  errorDesc: string;
  emailLabel: string;
  emailPlaceholder: string;
  resendButton: string;
  modalTitle: string;
  modalInstruction: string;
  invalidEmail: string;
  modalGenerate: string;
  cancel: string;
  modalSentDesc: string;
  resetTitle: string;
  resetSubtitle: string;
  newPasswordLabel: string;
  newPasswordConfirmLabel: string;
  passwordPlaceholder: string;
  show: string;
  hide: string;
  required: string;
  minLength: string;
  passwordsMatch: string;
  save: string;
  passwordChangedTitle: string;
  passwordChangedDesc: string;
};

export const strings: Record<Lang, Strings> = {
  pt: {
    footerVisit: "Visitar o site",
    verifyTitle: "Confirmação de e-mail",
    verifyInstruction: "Confirme seu e-mail clicando no botão abaixo.",
    verifyButton: "Confirmar e-mail",
    toastDoneTitle: "Pronto!",
    toastVerifiedDesc: "E-mail confirmado",
    toastErrorTitle: "Opa!",
    genericError: "Algo deu errado com sua solicitação. Verifique e tente novamente.",
    successTitle: "Obrigado por se juntar a nós!",
    successDesc: "Seu e-mail foi confirmado com sucesso.",
    errorTitle: "Opa!",
    errorDesc: "Algo deu errado com a confirmação do seu e-mail.",
    emailLabel: "E-mail:",
    emailPlaceholder: "Seu e-mail",
    resendButton: "Reenviar e-mail",
    modalTitle: "Reenviar link de confirmação",
    modalInstruction: "Informe seu e-mail para enviarmos um novo link de confirmação.",
    invalidEmail: "E-mail inválido",
    modalGenerate: "Gerar novo link",
    cancel: "Cancelar",
    modalSentDesc: "Novo link de confirmação enviado para o seu e-mail.",
    resetTitle: "Redefinir senha",
    resetSubtitle: "Escolha sua nova senha",
    newPasswordLabel: "Nova senha:",
    newPasswordConfirmLabel: "Confirmação da nova senha:",
    passwordPlaceholder: "Digite sua senha",
    show: "Mostrar",
    hide: "Ocultar",
    required: "Obrigatório",
    minLength: "Deve ter pelo menos 6 caracteres",
    passwordsMatch: "As senhas devem coincidir",
    save: "Salvar",
    passwordChangedTitle: "Senha alterada",
    passwordChangedDesc: "Agora você pode voltar ao Xlung App com sua nova senha.",
  },
  en: {
    footerVisit: "Visit Website",
    verifyTitle: "Email confirmation",
    verifyInstruction: "Please confirm your E-mail by clicking on the button below.",
    verifyButton: "Confirm your E-mail",
    toastDoneTitle: "Done!",
    toastVerifiedDesc: "E-mail verified",
    toastErrorTitle: "Oops!",
    genericError: "Something went wrong with your request. Please verify and try again.",
    successTitle: "Thank you for joining us!",
    successDesc: "Your E-mail was confirmed successfully.",
    errorTitle: "Oops!",
    errorDesc: "Something went wrong with your E-mail confirmation.",
    emailLabel: "E-mail:",
    emailPlaceholder: "Your E-mail",
    resendButton: "Resend E-mail",
    modalTitle: "Resend E-mail confirmation link",
    modalInstruction: "Please inform your E-mail so we can send you a new confirmation link.",
    invalidEmail: "Invalid E-mail",
    modalGenerate: "Generate new link",
    cancel: "Cancel",
    modalSentDesc: "New confirmation link sent to your E-mail.",
    resetTitle: "Password Reset",
    resetSubtitle: "Choose your new password",
    newPasswordLabel: "New Password:",
    newPasswordConfirmLabel: "New password confirmation:",
    passwordPlaceholder: "Enter your password",
    show: "Show",
    hide: "Hide",
    required: "Required",
    minLength: "Must be at least 6 characters long",
    passwordsMatch: "Both passwords must match",
    save: "Save",
    passwordChangedTitle: "Password changed",
    passwordChangedDesc: "Now you can go back to Xlung App using your new password.",
  },
};
